import React from "react";
import { Box, IconButton } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

const mobileHeaderCellSx = {
  fontWeight: "bold",
  padding: "8px 12px",
  textAlign: "left",
  borderRight: "1px solid #ddd",
  whiteSpace: "normal",
  wordBreak: "break-word",
  display: "flex",
  alignItems: "center",
  minWidth: 0,
  overflow: "hidden",
  boxSizing: "border-box",
//   borderTop: "1px solid #ddd",
// borderBottom: "1px solid #ddd",

// Every data-row grid
// borderBottom: "1px solid #ddd",
};

export const MobileColumnHeading = ({ title, handleSort, field, sortConfig }) => (
  <Box
    sx={{
      ...mobileHeaderCellSx,
      paddingLeft: title === "Date" ? "16px" : "12px",
      gap: "6px",
      minHeight: "100%",
      display: "flex",
      mt: "0",
    }} 
  >
    <Box component="span" sx={{ flex: 1, minWidth: 0, lineHeight: 1.3 }}>
      {title}
    </Box>
    <Box
      sx={{
        display: "flex",   
        flexDirection: "column",
        alignItems: "center",
        flexShrink: 0,
        width: "22px",
      }}
    >
      <IconButton
        size="small"
        sx={{ p: 0, height: "14px", width: "22px" }}
        onClick={() => handleSort(field, "asc")}
      >
        <ExpandLess
          sx={{
            fontSize: "18px",
            color:
              sortConfig.key === field && sortConfig.direction === "asc"
                ? "blue"
                : "black",
          }}
        />
      </IconButton>
      <IconButton
        size="small"
        sx={{ p: 0, height: "14px", width: "22px" }}
        onClick={() => handleSort(field, "desc")}
      >
        <ExpandMore
          sx={{
            fontSize: "18px",
            color:
              sortConfig.key === field && sortConfig.direction === "desc"
                ? "blue"
                : "black",
          }}
        />
      </IconButton>
    </Box>
  </Box>
);

export const mobileGridSx = (columnWidth, stretch = false) => ({
  display: "grid",
  gridTemplateColumns: columnWidth,
  alignItems: "stretch",
  "& > *": {
    minWidth: 0,
    overflow: "hidden",
    boxSizing: "border-box",
  },
  "& > .MuiTypography-root": {
    padding: "4px 10px",
    minHeight: 36,
    display: "flex",
    alignItems: "center",
    fontSize: "14px",   
    lineHeight: 1.25,
  },
});

